import React, { FC } from 'react';
import classes from './LicenseCard.module.scss';
import { LicenseTypeEnum, LicenseTypeNames } from '../../../../types/enums';
import Typography, { TypographyVariant } from '../../../Typography/Typography';
import classNames from 'classnames';
import { format, parseISO } from 'date-fns';

type Props = {
  licenseType: LicenseTypeEnum;
  licenseKey: string;
  isActive: boolean;
  startTime: string;
  endTime: string;
};

export const LicenseCard: FC<Props> = ({
  licenseType,
  licenseKey,
  isActive,
  startTime,
  endTime
}) => {
  return (
    <div className={classes.licenseCardWrapper}>
      <Typography variant={TypographyVariant.h4_regular} className={classes.serviceInfo}>
        Тип лицензии:
        <span>{LicenseTypeNames[licenseType]}</span>
      </Typography>

      <Typography variant={TypographyVariant.h4_regular} className={classes.serviceInfo}>
        Текущий ключ:
        <span>{licenseKey}</span>
      </Typography>

      <Typography variant={TypographyVariant.h4_regular} className={classes.serviceInfo}>
        Статус:
        <span className={classNames({ [classes.active]: isActive, [classes.inactive]: !isActive })}>
          {isActive ? 'активна' : 'неактивна'}
        </span>
      </Typography>

      <Typography variant={TypographyVariant.h4_regular} className={classes.serviceInfo}>
        Срок действия:
        <span>
          {format(parseISO(startTime), 'dd.MM.yyyy')} - {format(parseISO(endTime), 'dd.MM.yyyy')}
        </span>
      </Typography>
    </div>
  );
};
